import { jsx as _jsx } from "react/jsx-runtime";
import { Header } from '@at/design-system-collections';
import { useAppContext } from '@at/sauron-platform-core';
import React, { Suspense, useState } from 'react';
import { useLocation } from 'react-router';
import { getCookieName } from './util/cookie-utils';
import { usePageState } from '@at/sauron-platform-core';
import { useUserState } from '@at/connected-signin';
import { useATTrackInteraction } from '@at/consumer-web-snowplow';
const LazyATSlideSignInComponent = React.lazy(() => import(
/* webpackChunkName: "LazyATSlideSignInComponent" */
// @ts-ignore
'@at/connected-signin/lib/slide-signin.component'));
export const isUserSignedInFromCookie = () => {
    return getCookieName('ursid') != null;
};
export const buildAfterSignInUrl = (pathname, search) => {
    return encodeURIComponent(`${pathname}${search}`);
};
export const useHeaderTrackingCallbacks = () => {
    const trackInteraction = useATTrackInteraction();
    return {
        onAccountClick: () => trackInteraction({ trackingLabel: 'nav-account' }),
        onLogoClick: () => trackInteraction({ trackingLabel: 'nav-logo' }),
        onSellClick: () => trackInteraction({ trackingLabel: 'nav-sell-your-car-icon' }),
        onSearchClick: () => trackInteraction({ trackingLabel: 'nav-search' }),
        onSavedClick: () => trackInteraction({ trackingLabel: 'nav-saved' }),
        onNavigationClick: ({ labelIdentifier }) => {
            trackInteraction({
                trackingLabel: labelIdentifier,
            });
        },
    };
};
export const ConnectedHeader = (props) => {
    const { afterSignInCallback } = props;
    const [userState] = useUserState();
    const trackingHeadingCallbacks = useHeaderTrackingCallbacks();
    const { state: { channel }, } = usePageState();
    const { config: { env }, } = useAppContext();
    const [showSignInModal, setShowSignInModal] = useState(false);
    const { pathname, search } = useLocation();
    const afterSignInUrl = buildAfterSignInUrl(pathname, search);
    return (_jsx(Header, Object.assign({ trackingCallbacks: trackingHeadingCallbacks }, props, { userSignedIn: userState === null || userState === void 0 ? void 0 : userState.userSignedIn, channel: channel || props.channel, env: env, useNewSignIn: true, setShowSignInModal: setShowSignInModal }, { children: showSignInModal && (_jsx(Suspense, Object.assign({ fallback: "" }, { children: _jsx(LazyATSlideSignInComponent, { showing: showSignInModal, setShowing: setShowSignInModal, afterSigninUrl: afterSignInUrl, afterSignInCallback: () => {
                    afterSignInCallback === null || afterSignInCallback === void 0 ? void 0 : afterSignInCallback();
                } }) }))) })));
};
